import { ZONE_POLYGON_COLORS } from "@/features/sku-sections/lib/polygon-colors";
import { ZoneProjectionRendererProps } from "@/features/zone-projections";
import { Text, Group, Line } from "react-konva";
import { Dimensions } from "@/shared";

export function ZoneProjectionPolygons({
  canvasDimensions,
  zoneProjections,
  isOverflownProjectionsVisible,
  isOutsideView,
  highlightedZoneId,
}: ZoneProjectionRendererProps & {
  canvasDimensions: Dimensions;
  highlightedZoneId?: string | null;
}) {
  const getCenter = (polygon: [number, number][]) => {
    const x =
      polygon.reduce((sum, point) => (sum += point[0]), 0) / polygon.length;
    const y =
      polygon.reduce((sum, point) => (sum += point[1]), 0) / polygon.length;

    return [x, y];
  };

  const downscale = ([x, y]: [number, number]) =>
    [
      (x / 1920) * canvasDimensions.width,
      (y / 1080) * canvasDimensions.height,
    ] as [number, number];

  const isHighlighted = (polygonId: string) => {
    return highlightedZoneId ? polygonId === highlightedZoneId : false;
  };

  return zoneProjections.map((polygon) => {
    const downscaledPoints = polygon.projection.map(downscale);
    const labelPosition = getCenter(downscaledPoints);
    const highlighted = isHighlighted(polygon.id);

    if (!isOverflownProjectionsVisible && isOutsideView(polygon.projection)) {
      return null;
    }

    const colors = highlighted
      ? ZONE_POLYGON_COLORS.HIGHLIGHTED
      : ZONE_POLYGON_COLORS.DEFAULT;

    return (
      <Group key={polygon.id}>
        <Line
          points={downscaledPoints.flatMap((point) => point)}
          fill={colors.FILL}
          stroke={colors.STROKE}
          strokeWidth={highlighted ? 2 : 1}
          closed
          opacity={1}
          name="zone-projection"
          id={polygon.id}
          shadowBlur={highlighted ? 15 : 0}
          shadowColor={colors.STROKE}
          shadowOpacity={highlighted ? 0.8 : 0.4}
        />

        <Text
          text={polygon.description}
          fill={colors.TEXT}
          fontSize={highlighted ? 14 : 12}
          fontFamily="Inter, sans-serif"
          fontStyle={highlighted ? "bold" : "normal"}
          x={labelPosition[0] - 100}
          y={labelPosition[1] - 20}
          align="center"
          verticalAlign="middle"
          width={200}
          height={40}
          listening={false}
          shadowColor={colors.SHADOW}
          shadowOpacity={0.7}
        />
      </Group>
    );
  });
}
